import { View, ViewProps } from "react-native"
import { cn } from "@src/utils"
import { Text, TypographyProps } from "./typography"

function Card({ className, ...props }: ViewProps) {
  return <View className={cn("rounded-lg border border-gray-200 bg-white shadow-sm", className)} {...props} />
}

function CardHeader({ className, ...props }: ViewProps) {
  return <View className={cn("flex flex-col space-y-1.5 p-6", className)} {...props} />
}

function CardTitle({ className, ...props }: TypographyProps) {
  return <Text variant="h3" className={cn("text-2xl font-semibold leading-none tracking-tight", className)} {...props} />
}

function CardDescription({ className, ...props }: TypographyProps) {
  return <Text variant="muted" className={cn("text-sm text-gray-500", className)} {...props} />
}

function CardContent({ className, ...props }: ViewProps) {
  return <View className={cn("p-6 pt-0", className)} {...props} />
}

function CardFooter({ className, ...props }: ViewProps) {
  return <View className={cn("flex flex-row items-center p-6 pt-0", className)} {...props} />
}

export { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter }
